import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

declare const $: any;


@Component({
  selector: 'app-modal-modalities',
  templateUrl: './modal-modalities.component.html',
  styleUrls: ['./modal-modalities.component.css']
})
export class ModalModalitiesComponent implements OnInit {

  constructor(
    private translate : TranslateService
  ) { }

  ngOnInit() {
  }

  close(){
    // data-dismiss="modal" aria-label="Close"
    $('#modal-modalities').modal('hide');
    $('#modal-login').modal('show');
  }
}
